import { FC } from "react";
import { Link } from "react-router-dom";
import withPage from "../../components/Page";
import Section from "../../components/Section";
import { globalContent } from "../../config/content";
import styles from "./CookiePolicy.module.scss";

const CookiePolicy: FC = () => {
  return (
    <div className={styles.cookiePage}>
      <Section bgColor="white" sectionClass={styles.legalSection}>
        <div className={styles.legalContainer}>
          <div className={styles.pageHeader}>
            <h1 className={styles.h1}>Cookie Policy</h1>
            <p className={styles.leadText}>
              This Cookie Policy explains how cookies and similar technologies are used on the Pulse website.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>What are cookies?</h2>
            <p className={styles.paragraph}>
              Cookies are small text files or similar technologies that can be stored on a user's device when they visit a website.
            </p>
            <p className={styles.paragraph}>
              They can allow a website to remember information, provide functionality, maintain security or understand how the website is used.
            </p>
            <p className={styles.paragraph}>
              Some cookies are necessary for the website to function, while others may be optional depending on the technologies implemented.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>How we use cookies</h2>
            <p className={styles.paragraph}>
              The Pulse website uses essential cookies or similar technologies necessary for basic website operation, security and navigation.
            </p>
            <p className={styles.paragraph}>
              We do not use advertising, tracking or non-essential analytics cookies on this website.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Types of cookies we use</h2>
            <h3 className={styles.subHeading}>Essential cookies</h3>
            <p className={styles.paragraph}>
              These are necessary for the website to function properly and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Managing cookies</h2>
            <p className={styles.paragraph}>
              You can control or block cookies through your browser settings.
            </p>
            <p className={styles.paragraph}>
              Most browsers allow you to refuse cookies or delete existing cookies. The method varies depending on your browser and device.
            </p>
            <p className={styles.paragraph}>
              Please note that blocking essential cookies may affect how the website functions or prevent certain features from working properly.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Changes to this policy</h2>
            <p className={styles.paragraph}>
              This Cookie Policy may be updated when the website, technologies used or applicable legal requirements change.
            </p>
            <p className={styles.paragraph}>
              The latest version will always be published on this page.
            </p>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.sectionHeading}>Contact us</h2>
            <p className={styles.paragraph}>
              If you have any questions about this Cookie Policy or how cookies are used on the Pulse website, please visit our <Link to="/contact" className={styles.link}>Contact page</Link>. For more information on privacy, please see our <Link to="/privacy-policy" className={styles.link}>Privacy Policy</Link>.
            </p>
          </div>

          <div className={styles.lastUpdated}>
            Last updated: October 2026
          </div>
        </div>
      </Section>
    </div>
  );
};

export default withPage(CookiePolicy)({
  meta: globalContent.seo.cookies,
});
